// Maps org path_acronym to its external course portal login URL.
// Used when a course has moodle_synced=false (no Moodle SSO available).
// To add a new org: add an entry keyed by its path_acronym.
const COURSE_PROVIDER_URLS = {
  slc: "https://slc-campus.avallainmagnet.com/merospharm",
  bca: "https://slc-campus.avallainmagnet.com/bca",
};

const COURSE_PROVIDER_LOGOS = {
  slc:   "/img/stm/slc_logo.png",
  meros: "/img/stm/meros.png",
};

export function getCourseProviderUrl(pathAcronym) {
  if (!pathAcronym) return COURSE_PROVIDER_URLS.slc;
  return COURSE_PROVIDER_URLS[pathAcronym.toLowerCase()] || COURSE_PROVIDER_URLS.slc;
}

const DEFAULT_LOGO = "/img/new_tf_logo_icon.png";

export function getCourseProviderLogo(providerName) {
  if (!providerName) return DEFAULT_LOGO;
  const name = providerName.toLowerCase();
  if (name.includes("meros")) return COURSE_PROVIDER_LOGOS.meros;
  if (name.includes("slc") || name.includes("specialist language")) return COURSE_PROVIDER_LOGOS.slc;
  return DEFAULT_LOGO;
}
